import 'whatwg-fetch';
import { EMPTY_OBJECT } from '../../constants';
import config from '../../config';
import sigV4Client from './sigV4Client';
import { HTTP_STATUS } from '../http';

export async function signAndFetch(
  credentials,
  {
    path,
    method = 'GET',
    headers = EMPTY_OBJECT,
    queryParams = EMPTY_OBJECT,
    body,
    endpoint,
  }
) {
  const signedRequest = sigV4Client
    .newClient({
      accessKey: credentials.accessKeyId,
      secretKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken,
      region: config.api.region,
      endpoint: endpoint || config.api.licenseUrl,
    })
    .signRequest({
      method,
      path: encodeURI(path),
      headers,
      queryParams,
      body,
    });

  const bodyString = body ? JSON.stringify(body) : body;

  const results = await fetch(signedRequest.url, {
    method,
    headers: signedRequest.headers,
    body: bodyString,
  });

  if (!results.ok) {
    let value;
    try {
      value = await results.json();
      if (value.message) {
        value = value.message;
      }
    } catch (e) {
      console.warn(e);
      value = await results.text();
    }
    throw new Error(value);
  }

  if (results.status === HTTP_STATUS.NoContent) {
    return;
  }

  return results.json();
}



// WEBPACK FOOTER //
// ./src/lib/aws/api.js